import { IChecklistItem } from "@mctypes/checklist.types";
import { IMinUserDepricated } from "@mctypes/global.types";
import { createSelector } from "@reduxjs/toolkit";
import { IRootState } from "../../../store";

const selectChecklistItems = (state: IRootState): IChecklistItem[] => state.checklistReducer.checklistItems;

export const selectLatestChecklistChangeLabel = createSelector([selectChecklistItems], (items): string | null => {
  const latestChange = (items ?? []).reduce((latest, item) => {
    const candidates = [
      {
        updatedDate: item.inactive?.updatedDate,
        updatedBy: item.inactive?.updatedBy,
      },
      ...Object.values(item.checks ?? {}),
    ];

    candidates.forEach((candidate) => {
      if (candidate?.updatedDate == null) {
        return;
      }

      const candidateDate = new Date(candidate.updatedDate);
      if (Number.isNaN(candidateDate.getTime())) {
        return;
      }

      if (latest == null || candidateDate > latest.updatedDate) {
        latest = {
          updatedDate: candidateDate,
          updatedBy: candidate.updatedBy,
        };
      }
    });

    return latest;
  }, null as { updatedDate: Date; updatedBy?: string | IMinUserDepricated } | null);

  if (latestChange == null) {
    return null;
  }

  const formattedDate = latestChange.updatedDate.toLocaleString("no-NO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  const updatedBy = typeof latestChange.updatedBy === "string" ? "" : latestChange.updatedBy?.name;

  return updatedBy ? `${formattedDate}` : formattedDate;
});
